module.exports = __webpack_public_path__ + "static/media/poikiliasm_thumb2.bed643d6.jpg";